import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { IModule } from '../GestionFonctionnalite/Module/moduleSlice';



export interface ICommonListe {
    data: any;
    deleteItem: any;
    setItem?: any;
    handleEditDialogOpen: any;
}


export default function CommonListe(props: ICommonListe) {

    const { data, deleteItem, setItem, handleEditDialogOpen } = props

    const dispatch = useDispatch()


    const [selectedIndex, setSelectedIndex] = React.useState(null);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: any, item: IModule
    ) => {
        setSelectedIndex(index);
        dispatch(setItem(item))
    };


    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <List dense={true}>
                {data.map((item: any, index: any) => {
                    return (
                        <div key={index}>
                            <ListItem
                                secondaryAction={
                                    <div style={{ display: "flex" }} >
                                        <IconButton
                                        // disabled
                                            onClick={() => handleEditDialogOpen(item)}
                                        >
                                            <ModeEditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton
                                        // disabled
                                            onClick={() => deleteItem(item)}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                }
                            >
                                <ListItemButton
                                    selected={selectedIndex === index}
                                    onClick={(event) => handleListItemClick(event, index, item)}
                                >
                                    <ListItemText
                                        onClick={(event) => console.log("aaaaaa")}
                                        primary={item.libelle}
                                    // secondary={item.id}
                                    />
                                </ListItemButton>
                            </ListItem>
                            <Divider />
                        </div>
                    )
                })}
            </List>
        </Box>
    );
}
